import { useQuery } from '@tanstack/react-query';
import { PROJECT_QUERY_KEYS, ProjectQueries } from '@api/services/project';

export const useExistingProjects = (hasExistingProject: boolean) => {
  return useQuery({
    queryKey: [PROJECT_QUERY_KEYS.GET_EXISTING_PROJECT],
    queryFn: () => ProjectQueries.getExistingProjectsBasicInfo(),
    enabled: hasExistingProject,
  });
};

export const useProjectLocation = ({
  hasLocationData,
  projectId,
  projectVersion,
}: {
  hasLocationData?: boolean;
  projectId: number;
  projectVersion?: number;
}) => {
  return useQuery({
    queryKey: [PROJECT_QUERY_KEYS.GET_PROJECT_LOCATION, projectId, projectVersion],
    queryFn: () => ProjectQueries.getProjectLocationData(projectId, projectVersion),
    enabled:
      !hasLocationData &&
      Number.isInteger(projectId) &&
      (projectVersion === undefined || Number.isInteger(projectVersion)),
  });
};
